export const COMPARISON_SELECTION_CHANGE_EVENT = 'vitrine:comparison-selection-change';

interface IdentifiedSelection { id: number }

function countIds(value: unknown): number {
  if (typeof value !== 'string') return 0;
  return Math.min(4, new Set(value.split(',').map(Number).filter((id) => Number.isInteger(id) && id > 0)).size);
}

function readStoredComparisonCount(): number {
  if (typeof window === 'undefined') return 0;
  try {
    const selection = JSON.parse(window.sessionStorage.getItem('comparison') ?? '[]') as unknown;
    if (!Array.isArray(selection)) return 0;
    return Math.min(4, new Set(selection
      .map((item) => (item && typeof item === 'object' ? (item as IdentifiedSelection).id : null))
      .filter((id): id is number => typeof id === 'number' && Number.isInteger(id) && id > 0))
      .size);
  } catch { return 0; }
}

export function getComparisonCount(pathname: string, search: string): number {
  const params = new URLSearchParams(search);
  if (pathname === '/comparar') {
    const routeSelection = params.get('politicos') ?? params.get('ids');
    if (routeSelection !== null) return countIds(routeSelection);
  }
  return readStoredComparisonCount();
}

export function saveComparisonSelection<T extends IdentifiedSelection>(selection: readonly T[]): void {
  if (typeof window === 'undefined') return;
  try {
    if (selection.length) window.sessionStorage.setItem('comparison', JSON.stringify(selection));
    else window.sessionStorage.removeItem('comparison');
  } catch { /* A indisponibilidade do armazenamento não deve interromper a seleção. */ }
  window.dispatchEvent(new Event(COMPARISON_SELECTION_CHANGE_EVENT));
}
